export default __webpack_public_path__ + "static/media/StopIcon.8a06cf01.svg";